import React from 'react';
import { Text, StyleSheet } from 'react-native';
import theme from '../config/theme';

type Props = {
  message: string | null;
  visible?: boolean;
};

/**
 * Componente para exibir mensagens de erro abaixo de campos de formulário
 */
const FormFieldError: React.FC<Props> = ({ message, visible = true }) => {
  if (!message || !visible) return null;
  
  return (
    <Text style={styles.errorText}>{message}</Text>
  );
};

const styles = StyleSheet.create({
  errorText: {
    color: theme.colors.util.error,
    fontSize: theme.fontSizes.sm,
    marginTop: -4,
    marginBottom: theme.spacing.sm,
    marginLeft: theme.spacing.xs,
  },
});

export default FormFieldError; 